import { memo } from 'react'
import { List, ListItem } from '@mui/material'
import { Button, UserInfo } from '@collaborate-health/uikit'
import { setOwnerForSharing } from '@tabeeb/modules/sessionsPage/actions'
import { useDispatch, useSelector } from '@tabeeb/store'
import { getFoundUsersForReview } from '@tabeeb/modules/sessionsPage/selectors/reviews'
import { StyledUserSearchResultContainer } from './SearchUsersResult.styles'

interface User {
  Id: number
  Name: string
  Email: string
  AvatarUrl: string
}

const SearchUsersResult = () => {
  const dispatch = useDispatch()
  const users = useSelector(getFoundUsersForReview)

  return (
    <StyledUserSearchResultContainer pr={0.5} overflow='auto'>
      <List dense disablePadding>
        {users.map((user: User) => (
          <ListItem key={user.Id} dense disableGutters>
            <UserInfo item={user} />
            <Button size='small' color='primary' variant='outlined' onClick={() => dispatch(setOwnerForSharing(user))}>
              Select
            </Button>
          </ListItem>
        ))}
      </List>
    </StyledUserSearchResultContainer>
  )
}

export default memo(SearchUsersResult)

